import { Injectable } from '@angular/core';
/** RXJS */
import { Subject , BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  public menuClickEvent = new Subject<any>( ); //subject subscribable

  public menuLinks = new BehaviorSubject<any>( [] );
  public menuLayout = new BehaviorSubject<any>( 'app' );

  constructor() { 
    
  }

  public menuClick( method : string, args : [] ){
    this.menuClickEvent.next( { method: method , args: args } );
  }
  /**
   * 
   * @param newMenuLinks {array}
   * structure should be sections with props for title and links
   * [ { title: 'Section One' , links: [ ] } ]
   */
  public updateMenuLinks( newMenuLinks : any ){
    this.menuLinks.next( newMenuLinks );
  }

  public proofingLayout(  ){
    this.menuLayout.next( 'proofing' );
  }
}
